import React from "react";
import Style from "../../styles/js/StyleUsers";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";

function DataUser({
  photoUrl,
  name,
  lastName,
  birthDate,
  gender,
  phoneNumber,
  email,
}) {
  const style = Style();

  return (
    <div className={style.flexRow}>
      <div className={style.nameAvatar}>
        <Avatar alt="Travis Howard" src={photoUrl} className={style.avatar} />
        <Typography variant="h4" gutterBottom style={{ marginLeft: "10px" }}>
          {name} {lastName}
        </Typography>
      </div>
      <div className={style.data}>
        <div className={style.itemData}>
          <Typography gutterBottom>
            Fecha de nacimiento:{" "}
            {birthDate !== undefined ? birthDate : "Sin datos"}
          </Typography>
        </div>
        <div className={style.itemData}>
          <Typography gutterBottom>
            Genero:{" "}
            {gender === undefined
              ? "Sin datos"
              : gender === 0
              ? "Masculino"
              : "Femenino"}
          </Typography>
        </div>
        <div className={style.itemData}>
          <Typography gutterBottom>
            Telefono: {phoneNumber !== undefined ? phoneNumber : "Sin datos"}
          </Typography>
        </div>
        <div className={style.itemData}>
          <Typography gutterBottom>
            E-mail: {email !== undefined ? email : "Sin datos"}
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DataUser);
